import consumer from "./consumer"

consumer.subscriptions.create({ channel: "UpdatesChannel" }, {
  received(data) {
    notify(data);
  },

  connected() {
    console.log("Connected to Updates Channel");
  },

  disconnected() {
    console.log("Disconnected from Updates Channel");
  }
})

function notify(data) {
  let locale = 'en';
  const localeTag = document.querySelector("meta[name='locale']");
  if (localeTag) {
    locale = localeTag.getAttribute('content');
  }

  switch (data.action) {
    case "comment.new":
      Rails.ajax({
        url: `/${locale}/comments/${data.data.parent}/${data.data.parent_uuid}/load`,
        type: "get",
        data: "",
        success: function(data) {},
        error: function(data) {}
      });
      break;
    case "task.new":
      let body = document.querySelector("body")
      if(body.dataset.page == "start_index") {
        location.reload();
      } else if(body.dataset.project == data.project) {
        if(body.dataset.page == "tasks") {
          location.reload();
        }
      }
      break;
    default:
      console.log(`No event for action ${data.action}`);
  }
}
